module.exports = __webpack_public_path__ + "static/media/arrowReading.267d53f4.svg";